import { UGEStrokeSize } from '../types'

export function labelFromStrokeSize(size: UGEStrokeSize): string {
    switch (size) {
        case 'none':
            return 'None'
        case 'thin':
            return 'Thin'
        case 'normal':
            return 'Normal'
        case 'thick':
            return 'Thick'
    }
}

export function widthFromStrokeSize(size: UGEStrokeSize): number {
    switch (size) {
        case 'none':
            return 0
        case 'thin':
            return 2
        case 'normal':
            return 4
        case 'thick':
            return 6
    }
}
